import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DataResolverService } from './services/resolver/data-resolver.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: './login/login.module#LoginPageModule'
  },
  {
    path: 'logout',
    loadChildren: './login/login.module#LoginPageModule'
  },
  {
    path: 'machine',
    loadChildren: './machine/machine.module#MachinePageModule'
  },
  {
    path: 'line',
    loadChildren: './line/line.module#LinePageModule'
  },
  {
    path: 'pie',
    loadChildren: './pie/pie.module#PiePageModule'
  },
  {
    path: 'utilize',
    loadChildren: './utilize/utilize.module#UtilizePageModule'
  },
  {
    path: 'usage',
    loadChildren: './usage/usage.module#UsagePageModule'
  },
  {
    path: 'impression',
    loadChildren: './impression/impression.module#ImpressionPageModule'
  },
  {
    path: 'wip',
    children: [
      {
        path: '',
        loadChildren: './wip/wip.module#WipPageModule'
      },
      {
        path: 'process-selection/:id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './wip/wip-process-selection/wip-process-selection.module#WipProcessSelectionPageModule'
      },
      {
        path: 'chart/:id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './wip/wip-chart/wip-chart.module#WipChartPageModule'
      },
      {
        path: ':id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './wip/wip.module#WipPageModule'
      }
    ]
  },
  {
    path: 'output',
    children: [
      {
        path: '',
        loadChildren: './output/output.module#OutputPageModule'
      },
      {
        path: 'process-selection/:id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './output/output-process-selection/output-process-selection.module#OutputProcessSelectionPageModule'
      },
      {
        path: 'chart/:id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './output/output-chart/output-chart.module#OutputChartPageModule'
      },
      {
        path: 'machine-selection/:id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './output/output-machine-selection/output-machine-selection.module#OutputMachineSelectionPageModule'
      },
      {
        path: ':id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './output/output.module#OutputPageModule'
      }
    ]
  },
  {
    path: 'base-page',
    loadChildren: './shared/base-page/base-page.module#BasePagePageModule'
  },
  {
    path: 'operator',
    children: [
      {
        path: '',
        loadChildren: './operator/operator.module#OperatorPageModule'
      },
      {
        path: 'machine-down/:id',
        resolve: {
          special: DataResolverService
        },
        loadChildren: './operator/machine-down/machine-down.module#MachineDownPageModule'
      }
    ]
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
